import styled from 'styled-components'

import { Fonts } from './styles.common'

export const CompareGrid = styled.div`
  border-radius: 20px;
  column-gap: 0px;
  margin-top: 50px;
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr 1fr;
  grid-column-gap: 1px;
  background: #ffffff;
  filter: drop-shadow(0px 24px 48px rgba(112, 0, 153, 0.1));
  overflow: hidden;
`

export const CompareCell1 = styled.div`
  padding: 20px;
  text-align: left;
  border-bottom: 2px solid rgba(213, 212, 218, 0.5);
  font-family: DM Sans;
  background: #ffffff;
`

export const CompareCell2 = styled.div(({ isVertical }) => [
  `
  background: #f9f9fb;
  padding: 20px;
  border-bottom: 2px solid rgba(213, 212, 218, 0.5);
  font-family: DM Sans;
  `,
  isVertical && [`transform: rotate(-90deg);`]
])

export const CompareCell3 = styled(CompareCell2)`
  background: #ffffff;
`

export const CompareCell4 = styled(CompareCell3)`
  background: #f9f9fb;
`

export const Title = styled(Fonts)`
  font-weight: bold;
`

export const Text = styled(Fonts)`
  font-size: 18px;
  line-height: 200%;
  /* or 36px */

  letter-spacing: -0.05em;

  color: rgba(35, 35, 35, 0.6);
`

export const Bold = styled(Text)`
  color: #232323;
  line-height: 100%;
  font-weight: bold;
`
